var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 20 20"}},[_c('use',{attrs:{"xlink:href":'/icon/icons.svg' + _vm.href}})])}
var staticRenderFns = []

export { render, staticRenderFns }